import React from 'react'
import ReactDOM from 'react-dom'
import createLogger from 'redux-logger'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore, compose } from 'redux'
import App from './components/App'
import rootReducer, { defaultState } from './reducers'

export let startPeopleApp = (
  courseData,
  peopleData,
  sectionData,
  allSectionData,
  elevatedUser,
  chapterData,
  archivedData,
  videoData,
  peopleCount,
  archivedCount,
  sectionCount,
  supportDashboard
) => {
  const middleware =
    process.env.NODE_ENV !== 'production'
      ? applyMiddleware(thunk, createLogger())
      : applyMiddleware(thunk)
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const store = createStore(
    rootReducer,
    {
      ...defaultState,
      coursenum: courseData['coursenum'],
      courseTitle: courseData['courseTitle'],
      courseLms: courseData['courseLms'] === 'true',
      authorized: courseData['authorized'] === 'true',
      peopleRowData: peopleData,
      archivedRowData: archivedData,
      sectionRowData: sectionData,
      allSectionData: allSectionData,
      peopleCount: peopleCount,
      archivedCount: archivedCount,
      sectionCount: sectionCount,
      elevatedUser: elevatedUser,
      chapterData: chapterData,
      videoData: videoData,
      supportDashboard: supportDashboard,
      daysOfAccess: courseData['daysOfAccess'],
    },
    composeEnhancers(middleware)
  )
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('app')
  )
}
